import React, { FunctionComponent, useState, useEffect } from 'react';
import styled from 'styled-components';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { useMedia } from 'react-media-match';
import { useHistory } from 'react-router-dom';
import { Button } from '@empiriecom/module-components/Button';

const TagsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: row wrap;
`;

const TagWrapper = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.greyLight.color.normal};
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  margin: 0 0.5rem 0.5rem 0;
  border: 0px none;
  transition: color 0.2s ease-in-out;
  will-change: color;
  &&:hover,
  &&.active {
    color: ${({ theme }) => theme.primary.color.normal};
    border: 0px none;
  }
`;

const TagName = styled.span`
  margin-right: 0.25rem;
`;

interface TagProps {
  name: string;
  count: number;
  tagKey: string;
}

const Tag: FunctionComponent<TagProps> = ({ name, count, tagKey }) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [pathName, setPathName] = useState<string>();
  const history = useHistory();
  const tagFilter = history.location.pathname?.split('/').filter((part) => part.match(/f-\d+/));
  const onRatingPage = history.location.pathname.indexOf('/rating') > -1;

  useEffect(() => setIsActive(history.location.pathname.indexOf(`f-${tagKey}`) > -1));

  useEffect(() => {
    if (onRatingPage && isActive) {
      setPathName(history.location.pathname.replace(`/rating/${tagFilter.join('')}`, '/rating'));
    } else if (onRatingPage && !isActive && tagFilter.join() !== '') {
      setPathName(history.location.pathname.replace(/f-\d+/, `f-${tagKey}`));
    } else if (onRatingPage && !isActive) {
      setPathName(history.location.pathname.replace('/rating', `/rating/f-${tagKey}`));
    } else {
      setPathName(history.location.pathname.concat(`/rating/f-${tagKey}`));
    }
  }, [isActive]);

  return (
    <TagWrapper
      className={isActive ? 'active' : ''}
      onClick={() => {
        setIsActive(!isActive);
        history.replace({ ...history.location, pathname: pathName });
      }}
      uppercase={false}
    >
      <TagName>{name}</TagName>
      <span>({count})</span>
    </TagWrapper>
  );
};

interface TagsProps {
  tags: any;
}

export const Tags: FunctionComponent<TagsProps> = ({ tags }): JSX.Element => {
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });
  const scrollContent = tags.map((tag) => (
    <Tag key={tag.tag.key} name={tag.tag.name} count={tag.ratingCount} tagKey={tag.tag.key} />
  ));
  return isMobile ? (
    <ScrollMenu data={scrollContent} alignCenter={false} wheel={false} />
  ) : (
    <TagsContainer>{scrollContent}</TagsContainer>
  );
};

export default Tags;
